/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} End_Tolerance_SecondsInputs */

const en_end_tolerance_seconds = /** @type {(inputs: End_Tolerance_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End Tolerance (Seconds)`)
};

const fr_end_tolerance_seconds = /** @type {(inputs: End_Tolerance_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolérance de fin (secondes)`)
};

const de_end_tolerance_seconds = /** @type {(inputs: End_Tolerance_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endtoleranz (Sekunden)`)
};

const it_end_tolerance_seconds = /** @type {(inputs: End_Tolerance_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolleranza finale (secondi)`)
};

const ru_end_tolerance_seconds = /** @type {(inputs: End_Tolerance_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Допуск на конце (в секундах)`)
};

const es_end_tolerance_seconds = /** @type {(inputs: End_Tolerance_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolerancia final (segundos)`)
};

const zh_cn2_end_tolerance_seconds = /** @type {(inputs: End_Tolerance_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最终公差（秒）`)
};

const ja_end_tolerance_seconds = /** @type {(inputs: End_Tolerance_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終了許容値（秒）`)
};

const hi_end_tolerance_seconds = /** @type {(inputs: End_Tolerance_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंतिम सहनशीलता (सेकंड)`)
};

const pt_pt2_end_tolerance_seconds = /** @type {(inputs: End_Tolerance_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolerância final (segundos)`)
};

/**
* | output |
* | --- |
* | "End Tolerance (Seconds)" |
*
* @param {End_Tolerance_SecondsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const end_tolerance_seconds = /** @type {((inputs?: End_Tolerance_SecondsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<End_Tolerance_SecondsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_end_tolerance_seconds(inputs)
	if (locale === "de") return de_end_tolerance_seconds(inputs)
	if (locale === "it") return it_end_tolerance_seconds(inputs)
	if (locale === "ru") return ru_end_tolerance_seconds(inputs)
	if (locale === "es") return es_end_tolerance_seconds(inputs)
	if (locale === "zh-CN") return zh_cn2_end_tolerance_seconds(inputs)
	if (locale === "ja") return ja_end_tolerance_seconds(inputs)
	if (locale === "hi") return hi_end_tolerance_seconds(inputs)
	if (locale === "pt-PT") return pt_pt2_end_tolerance_seconds(inputs)
	return en_end_tolerance_seconds(inputs)
});